<template>
  <div class="page" :style="themeStyle">
    <div v-if="!loaded" class="loading">Loading</div>

    <div v-if="loaded" class="container">
      <div class="top">
        <div class="topLeft">
          <img v-if="loinfo && loinfo.main_logo" :src="loinfo.main_logo" class="logo" />
          <div class="topText">
            <div class="t1">{{ loName || "Loan Officer" }}</div>
            <div class="t2">Co-branded with {{ realtorName || realtor?.partner_title || 'Partner' }}</div>
          </div>
        </div>

        <div class="topRight">
   
        </div>
      </div>

      <div class="layout">
        <div class="hero">
          <div class="heroLeft">
    
            <div class="heroTitle" v-html="heroH1Html"></div>
            <div class="heroBody">{{ heroBody }}</div>

            <div class="heroBtns">
              <a class="btn big primary" :href="applyRightLink">{{ heroPrimaryText }}</a>
              <a v-if="applyLeftLink" class="btn big ghost" :href="applyLeftLink">{{ heroSecondaryText }}</a>
            </div>
          </div>

          <div class="heroRight">
            <div class="heroCard">
              <div class="heroMiniTitle">Quick links</div>
              <div class="heroPills">
                <a v-if="loinfo && loinfo.phone_number" class="pill pillBrand" :href="'tel:' + loinfo.phone_number">Call</a>
                <a v-if="loinfo && loinfo.email" class="pill pillBrand" :href="'mailto:' + loinfo.email">Email</a>
                <a v-if="realtor && realtor.website_url" class="pill pillBrand" :href="realtor.website_url" target="_blank" rel="noreferrer">Partner site</a>
              </div>
              <div class="heroFine">
                {{ loName || "Loan Officer" }}<span v-if="loTitle"> • {{ loTitle }}</span>
                <span v-if="loinfo && loinfo.nmls"> • NMLS {{ (loinfo.nmls || "").trim() }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="main">
          <div class="card">
            <div class="cardTopBar"></div>

            <div class="h">Loan Officer</div>
            <div class="row">
              <img v-if="loinfo && loinfo.lo_image" :src="loinfo.lo_image" class="avatar" />
              <div>
                <div class="name">{{ loName }}</div>
                <div class="meta">{{ loTitle }}</div>
                <div class="meta" v-if="loinfo && loinfo.nmls">NMLS {{ (loinfo.nmls || "").trim() }}</div>
              </div>
            </div>

            <div class="pills">
              <a v-if="loinfo && loinfo.phone_number" class="pill pillBrand" :href="'tel:' + loinfo.phone_number">{{ loinfo.phone_number }}</a>
              <a v-if="loinfo && loinfo.email" class="pill pillBrand" :href="'mailto:' + loinfo.email">{{ loinfo.email }}</a>
            </div>

            <div class="btns">
          
            </div>
          </div>
        </div>

        <div class="side">
          <div class="card">
            <div class="cardTopBar accent"></div>

            <div class="h"> {{ realtor?.partner_title || 'Partner' }}</div>
            <div class="row">
              <img v-if="realtor && realtor.headshot_url" :src="realtor.headshot_url" class="avatar" />
              <div>
                <div class="name">{{ realtorName }}</div>
                <div class="meta">{{ realtor && realtor.brokerage_name ? realtor.brokerage_name : "" }}</div>
                <div v-if="realtor && realtor.nmls" class="pcard-nmls">NMLS {{ (realtor.nmls || "").trim() }}</div>
              </div>
            </div>

            <div class="pills">
              <a v-if="realtor && realtor.phone_number" class="pill pillBrand" :href="'tel:' + realtor.phone_number">{{ realtor.phone_number }}</a>
              <a v-if="realtor && realtor.email" class="pill pillBrand" :href="'mailto:' + realtor.email">{{ realtor.email }}</a>
              <a v-if="realtor && realtor.website_url" class="pill pillBrand" :href="realtor.website_url" target="_blank" rel="noreferrer">Website</a>
            </div>
          </div>
        </div>
      </div>

      <div class="accentBar"></div>
    </div>
  </div>
</template>

<script>
import coBrandMixin from "../../mixins/coBrandMixin.js";

const BRAND_COLORS = {
  zonalending: { primary: "#eb610a", accent: "#646363" },
  radiantmortgage: { primary: "#1C1F39", accent: "#DB9457" },
  conradmortgage: { primary: "#4a4b4b", accent: "#d4af37" },
  theimgteam: { primary: "#ff6633", accent: "#4a4c54" },
  responsivemortgage: { primary: "#07212c", accent: "#FF7F47" },
  kpmortgage: { primary: "#0D2821", accent: "#34BFC6" },
  ignitemortgage: { primary: "#000000", accent: "#00b1eb" },
  tessst1: { primary: "#051d3a", accent: "#f66f35" },
  goldstarfinancial: { primary: "#0b1726", accent: "#c69c39" },
  integrityedgelending: { primary: "#051d3a", accent: "#f1b534" },
  nathomelending: { primary: "#94bfe1", accent: "#ec3150" },
  equitycmg: { primary: "#002328", accent: "#64ba53" },
  moderntitlegroup: { primary: "#4a4b4b", accent: "#00a8e0" },
  homeloansbyjen: { primary: "#051d3a", accent: "#bc845c" },
  ammortgagegroup: { primary: "#981b1f", accent: "#008fd5" },
  cityforstthisisuntilwegetapproval: { primary: "#051d3a", accent: "#f1b534" },
  test: { primary: "#051d3a", accent: "#c69c39" }
};

function getBrandKeyFromEmail(email) {
  if (!email || typeof email !== "string") return null;
  const at = email.indexOf("@");
  if (at < 0) return null;
  const domain = email.slice(at + 1).toLowerCase().trim();
  const first = domain.split(".")[0];
  return first || null;
}

function safePalette(primary, accent) {
  return {
    primary: (primary || "#0b1726").toLowerCase(),
    accent: (accent || "#c69c39").toLowerCase()
  };
}

export default {
  name: "CoBrandThemeSideBySide",
  mixins: [coBrandMixin],
  computed: {
    brandKey() {
      const fromEmail = getBrandKeyFromEmail(this.loinfo && this.loinfo.email);
      if (fromEmail && BRAND_COLORS[fromEmail]) return fromEmail;
      if (this.loinfo && this.loinfo.radiant === true && BRAND_COLORS.radiantmortgage) return "radiantmortgage";
      return "goldstarfinancial";
    },
    palette() {
      const b = BRAND_COLORS[this.brandKey] || BRAND_COLORS.goldstarfinancial;
      return safePalette(b.primary, b.accent);
    },
    themeStyle() {
      const { primary, accent } = this.palette;
      return {
        "--primary": primary,
        "--accent": accent
      };
    },
    
    heroH1Html() {
      const h = (this.realtor?.header1 || this.loinfo?.header1 || "").trim();
      if (!h) return "Ready to get<br/><em>started?</em>";
      const parts = h.split(",");
      if (parts.length > 1) {
        const a = parts[0].trim();
        const b = parts.slice(1).join(",").trim();
        return `${a}<br/><em>${b}</em>`;
      }
      return h;
    },
    
    heroHeading() {
      return this.loinfo && this.loinfo.text_section_heading ? this.loinfo.text_section_heading : "About";
    },
    heroPrimaryText() {
      return this.loinfo && this.loinfo.right_button_text ? this.loinfo.right_button_text : "Apply Now";
    },
    heroSecondaryText() {
      return this.loinfo && this.loinfo.left_button_text ? this.loinfo.left_button_text : "Schedule Appointment";
    },
     heroBody() {
      const m = (this.realtor?.main || this.loinfo?.main || "").trim();
      if (m) return m;
      const p = [this.loinfo?.text_section_body_p1, this.loinfo?.text_section_body_p2].filter(Boolean).join(" ").trim();
      return p || this.loinfo?.footer_slogan || "Start your application in minutes and we'll guide you from application through closing with a personal touch.";
    },
 
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: radial-gradient(1200px 600px at 20% 0%, color-mix(in srgb, var(--accent) 10%, white), #ffffff);
  color: #111827;

  --primary: #0b1726;
  --accent: #c69c39;

  --card-bg: #ffffff;
  --border: rgba(17, 24, 39, 0.14);
  --muted: #6b7280;

  --primary-soft: color-mix(in srgb, var(--primary) 14%, white);
  --accent-soft: color-mix(in srgb, var(--accent) 18%, white);
  --accent-line: color-mix(in srgb, var(--accent) 55%, white);
}

.loading { padding: 24px; }

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 22px 18px 40px;
  position: relative;
}

.accentBar {
  position: absolute;
  left: 18px;
  right: 18px;
  top: 0;
  height: 3px;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--accent), color-mix(in srgb, var(--accent) 35%, var(--primary)));
  opacity: 0.9;
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 14px;
  padding-top: 10px;
}

.topLeft { display: flex; align-items: center; gap: 14px; }
.topRight { display: flex; align-items: center; gap: 10px; }

.logo { width: 160px; height: auto; object-fit: contain; }

.t1 { font-size: 22px; font-weight: 900; color: var(--primary); }
.t2 { margin-top: 3px; color: var(--muted); }

.btn {
  text-align: center;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid var(--border);
  text-decoration: none;
  color: #111827;
  font-weight: 900;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn:hover { background: color-mix(in srgb, var(--accent) 10%, white); }

.primary {
  background: linear-gradient(180deg, color-mix(in srgb, var(--primary) 88%, black), var(--primary));
  border-color: color-mix(in srgb, var(--primary) 70%, black);
  color: #fff;
  box-shadow: 0 10px 22px rgba(0,0,0,0.12);
}

.primary:hover { filter: brightness(1.05); }

.topApply { padding: 10px 14px; border-radius: 999px;  }

.btn.big { padding: 12px 16px; border-radius: 14px; font-size: 14px;  width:55% }

.btn.ghost {
  background: #fff;
  border-color: color-mix(in srgb, var(--accent) 55%, var(--border));
  color: var(--primary);
}

.btn.ghost:hover { background: var(--accent-soft); }

.full { width: 100%; }

.layout {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 14px;
  grid-template-areas:
    "hero hero"
    "main side";
}

.hero { grid-area: hero; }
.main { grid-area: main; }
.side { grid-area: side; }

.hero {
  display: grid;
  grid-template-columns: 1.35fr 0.65fr;
  gap: 14px;
  padding: 16px;
  border-radius: 18px;
  border: 1px solid var(--accent-line);
  background:
    linear-gradient(180deg, color-mix(in srgb, var(--accent) 16%, white), #ffffff);
  box-shadow: 0 20px 40px rgba(0,0,0,0.06);
  position: relative;
  overflow: hidden;
}

.hero:before {
  content: "";
  position: absolute;
  top: -60px;
  right: -120px;
  width: 280px;
  height: 280px;
  border-radius: 999px;
  background: radial-gradient(circle at 30% 30%, var(--accent), transparent 60%);
  opacity: 0.18;
  pointer-events: none;
}

.heroKicker {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: color-mix(in srgb, var(--accent) 70%, var(--muted));
  font-weight: 950;
}

.heroTitle {
  margin-top: 6px;
  font-size: 28px;
  line-height: 1.15;
  font-weight: 950;
  color: var(--primary);
}

.heroBody { margin-top: 10px; color: #374151; line-height: 1.6; }
.heroBtns { display: flex; gap: 10px; margin-top: 14px; flex-wrap: wrap;  }

.heroCard {
  background: #ffffff;
  border: 1px solid var(--accent-line);
  border-radius: 16px;
  padding: 14px;
  box-shadow: 0 12px 26px rgba(0,0,0,0.08);
}

.heroMiniTitle {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--muted);
  font-weight: 950;
}

.heroPills { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; }
.heroFine { margin-top: 10px; font-size: 13px; color: var(--muted); }

.card {
  background: var(--card-bg);
  border: 1px solid var(--accent-line);
  border-radius: 16px;
  padding: 14px;
  box-shadow: 0 12px 26px rgba(0,0,0,0.05);
  position: relative;
  overflow: hidden;
}

.cardTopBar {
  height: 3px;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--primary), color-mix(in srgb, var(--primary) 55%, var(--accent)));
  margin-bottom: 10px;
}

.cardTopBar.accent {
  background: linear-gradient(90deg, var(--accent), color-mix(in srgb, var(--accent) 45%, var(--primary)));
}

.h {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  color: color-mix(in srgb, var(--primary) 75%, var(--muted));
  margin-bottom: 12px;
  font-weight: 950;
}

.row { display: flex; gap: 12px; align-items: center; }

.avatar {
  width: 74px;
  height: 74px;
  border-radius: 14px;
  object-fit: cover;
  border: 1px solid var(--accent-line);
  background: var(--accent-soft);
}

.name { font-size: 18px; font-weight: 950; color: var(--primary); }
.meta { margin-top: 3px; font-size: 13px; color: var(--muted); }

.pills { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px; }

.pill {
  border: 1px solid var(--accent-line);
  border-radius: 999px;
  padding: 7px 10px;
  font-size: 13px;
  text-decoration: none;
  color: var(--primary);
  background: #fff;
}

.pill:hover { background: var(--accent-soft); }

.pillBrand { border-color: var(--accent-line); }
.pillBrand:hover { background: var(--primary-soft); }

.btns { display: flex; gap: 10px; margin-top: 14px;  }

.cta {
  border-radius: 14px;
  padding: 12px 14px;
  font-size: 15px;
  letter-spacing: 0.01em;
}

@media (max-width: 900px) {
  .layout {
    grid-template-columns: 1fr;
    grid-template-areas:
      "hero"
      "main"
      "side";
  }
  .hero { grid-template-columns: 1fr; }
  .accentBar { left: 18px; right: 18px; }
}
</style>